import React from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import PortfolioDetails from '../../components/admincomponents/PortfolioDetails';

function ViewBlog({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <PortfolioDetails />            
    </>
  );
}

export default ViewBlog;
